export interface MovieRatingBreakdown {
  story: number;
  acting: number;
  visual: number;
  music: number;
}

export interface Movie {
  id: string;
  title: string;
  enTitle: string;
  poster: string;
  backdrop: string;
  genres: string[];
  category: string;
  year: number;
  releaseDate: string;
  rating: number;
  duration: number;
  director: string;
  cast: string[];
  region: string;
  tagline: string;
  synopsis: string;
  story: string;
  popularity: number;
  ratingBreakdown: MovieRatingBreakdown;
}

export const movies: Movie[] = [
  {
    id: "1",
    title: "逐光者",
    enTitle: "Chasing Light",
    poster: "https://readdy.ai/api/search-image?query=cinematic%20action%20movie%20key%20art%20poster%20of%20a%20lone%20silhouette%20standing%20before%20a%20massive%20glowing%20city%20rift%2C%20deep%20navy%20blue%20and%20crimson%20red%20neon%20accents%2C%20dramatic%20rim%20lighting%2C%20atmospheric%20haze%2C%20no%20text%2C%20no%20watermark%2C%20film%20grain%2C%20high%20detail%2C%20moody%20professional%20composition&width=600&height=900&seq=mv-p01&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20backdrop%20of%20a%20futuristic%20city%20skyline%20at%20night%20bathed%20in%20deep%20blue%20light%20with%20crimson%20red%20streaks%2C%20dramatic%20clouds%2C%20atmospheric%20haze%2C%20no%20text%2C%20no%20watermark%2C%20film%20grain%2C%20epic%20movie%20still%2C%20high%20detail&width=1600&height=900&seq=mv-b01&orientation=landscape",
    genres: ["action", "sci-fi"],
    category: "action",
    year: 2026,
    releaseDate: "2026-09-18",
    rating: 8.7,
    duration: 142,
    director: "林砚舟",
    cast: ["苏敬川", "顾清和", "沈亦白"],
    region: "中国大陆",
    tagline: "当所有灯光熄灭，我们成为彼此的光源",
    synopsis: "一场覆盖全球的能源危机之后，一名普通电工意外掌握了重启城市能量核心的钥匙，他必须在废墟与追捕之间做出选择。",
    story: "在不远的未来，持续运转的巨型城市能量网络突然失效，整座城市陷入漫长黑夜。一次意外抢修中，维修工程师陆寒发现在旧城区深处仍残留着一段未被污染的能源脉冲。为了唤醒它，他与曾经的对手、执着的研究员一同穿越层层封锁。沿途他们遭遇了利益集团的围堵，也遇到了愿意为微光牺牲的普通人。影片以冷峻的视觉语言讲述普通人在绝境中坚持与彼此照亮的故事，动作场面与情感线索交替推进。",
    popularity: 98,
    ratingBreakdown: { story: 8.5, acting: 8.8, visual: 9.2, music: 8.6 },
  },
  {
    id: "2",
    title: "深海回声",
    enTitle: "Echoes of the Deep",
    poster: "https://readdy.ai/api/search-image?query=cinematic%20science%20fiction%20movie%20key%20art%20poster%20showing%20a%20lone%20submersible%20descending%20into%20a%20vast%20dark%20ocean%20trench%20with%20faint%20blue%20bioluminescent%20glow%2C%20deep%20navy%20and%20teal%20tones%2C%20atmospheric%20particles%2C%20no%20text%2C%20no%20watermark%2C%20film%20grain%2C%20high%20detail%2C%20moody%20professional%20composition&width=600&height=900&seq=mv-p02&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20underwater%20scene%20of%20a%20deep%20ocean%20trench%20with%20faint%20bioluminescent%20blue%20light%20and%20floating%20particles%2C%20mysterious%20atmosphere%2C%20no%20text%2C%20no%20watermark%2C%20film%20grain%2C%20epic%20movie%20still%2C%20high%20detail&width=1600&height=900&seq=mv-b02&orientation=landscape",
    genres: ["sci-fi", "mystery"],
    category: "sci-fi",
    year: 2026,
    releaseDate: "2026-08-30",
    rating: 8.4,
    duration: 128,
    director: "周望川",
    cast: ["程未然", "罗砚书", "谢淮安"],
    region: "中国大陆",
    tagline: "海面之下的第一个回声，从来不是人类发出的",
    synopsis: "一支深海科考队在万米海沟捕捉到了规律的信号，随着下潜深入，他们发现这段回声正在回应每个人内心最深的记忆。",
    story: "为了验证一项关于深海声呐的新理论，科考队带着新型载人潜器驶向从未被探明的海沟。在下潜过程中，设备捕捉到了一段节奏异常精准的低频回声。队长坚持继续深入，而随队心理学者却发现，每名队员都在耳机中听见了属于自己的往事。当他们抵达海沟底部，真相与选择一同浮出水面。影片以克制的悬疑叙事，探讨记忆、孤独与人类对未知的敬畏。",
    popularity: 91,
    ratingBreakdown: { story: 8.6, acting: 8.3, visual: 8.9, music: 8.2 },
  },
  {
    id: "3",
    title: "长安夜行",
    enTitle: "Night Ride of Chang'an",
    poster: "https://readdy.ai/api/search-image?query=cinematic%20historical%20action%20movie%20poster%20of%20a%20cloaked%20rider%20galloping%20through%20an%20ancient%20lantern-lit%20eastern%20city%20gate%20at%20night%2C%20warm%20amber%20lanterns%20against%20deep%20navy%20sky%2C%20crimson%20banner%20accents%2C%20no%20text%2C%20no%20watermark%2C%20film%20grain%2C%20high%20detail%2C%20epic%20composition&width=600&height=900&seq=mv-p03&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20view%20of%20an%20ancient%20eastern%20imperial%20city%20at%20night%20with%20rows%20of%20glowing%20amber%20lanterns%2C%20misty%20streets%2C%20deep%20navy%20sky%2C%20no%20text%2C%20no%20watermark%2C%20film%20grain%2C%20epic%20movie%20still%2C%20high%20detail&width=1600&height=900&seq=mv-b03&orientation=landscape",
    genres: ["action", "drama"],
    category: "action",
    year: 2025,
    releaseDate: "2025-12-12",
    rating: 8.9,
    duration: 155,
    director: "秦墨白",
    cast: ["江子野", "温雨棠", "韩之遥"],
    region: "中国大陆",
    tagline: "一夜之间，整座城的命运都压在一次奔袭之上",
    synopsis: "一名被贬的城门守卫，在宵禁之夜接到一份不能公开的密令，他必须在破晓前穿过整座城，把真相送到对的人手里。",
    story: "古都的宵禁钟声敲响，街巷被灯笼与迷雾笼罩。守卫裴川因一桩旧案被贬至最偏的城门，却在当值之夜收到一封匿名的密信。信中之事若被证实，将动摇整座城的秩序。他选择相信自己的判断，骑马穿越重重关卡，一路上与追兵、旧友和内心的犹豫反复交锋。影片以紧凑的一夜时间为轴，将动作、权谋与情感交织成一幅古典长卷。",
    popularity: 95,
    ratingBreakdown: { story: 9.0, acting: 9.1, visual: 8.8, music: 8.7 },
  },
  {
    id: "4",
    title: "心跳频率",
    enTitle: "Heartbeat Frequency",
    poster: "https://readdy.ai/api/search-image?query=cinematic%20romance%20movie%20key%20art%20poster%20of%20two%20figures%20standing%20close%20under%20soft%20rain%20with%20warm%20pink%20and%20crimson%20bokeh%20lights%2C%20deep%20navy%20background%2C%20gentle%20glow%2C%20no%20text%2C%20no%20watermark%2C%20film%20grain%2C%20high%20detail%2C%20romantic%20moody%20composition&width=600&height=900&seq=mv-p04&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20rainy%20city%20street%20at%20night%20with%20warm%20bokeh%20lights%20and%20soft%20reflections%2C%20lonely%20figure%20with%20umbrella%2C%20deep%20navy%20and%20warm%20red%20tones%2C%20no%20text%2C%20no%20watermark%2C%20film%20grain%2C%20high%20detail&width=1600&height=900&seq=mv-b04&orientation=landscape",
    genres: ["romance"],
    category: "romance",
    year: 2026,
    releaseDate: "2026-07-08",
    rating: 8.1,
    duration: 118,
    director: "许清晏",
    cast: ["苏眠", "顾知遥", "白鹿鸣"],
    region: "中国大陆",
    tagline: "我们的故事，写在每一次同频的心跳里",
    synopsis: "一位用声音记录城市的心跳采集师，在录音室与一位电台主播意外相遇，两人用声音交换了彼此最不愿被听见的秘密。",
    story: "声音采集师程夏每天带着设备走遍城市，收集各种各样的心跳与呼吸。一次偶然，她在深夜电台里听到了主播顾知遥低沉的声音，并被那种节奏深深吸引。两人从声音开始认识彼此，在录音室的密闭上空间里分享各自的过往。影片用细腻的生活流叙事和大量声音设计，讲述一段关于倾听、勇气与靠近的爱情。",
    popularity: 84,
    ratingBreakdown: { story: 8.0, acting: 8.4, visual: 8.2, music: 8.6 },
  },
  {
    id: "5",
    title: "末班地铁",
    enTitle: "The Last Metro",
    poster: "https://readdy.ai/api/search-image?query=cinematic%20horror%20movie%20key%20art%20poster%20of%20an%20empty%20underground%20subway%20platform%20with%20flickering%20fluorescent%20lights%20and%20a%20distant%20shadowy%20figure%2C%20deep%20navy%20and%20sickly%20green%20accents%2C%20atmospheric%20fog%2C%20no%20text%2C%20no%20watermark%2C%20film%20grain%2C%20creepy%20high%20detail&width=600&height=900&seq=mv-p05&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20abandoned%20underground%20subway%20tunnel%20with%20flickering%20lights%20and%20heavy%20mist%2C%20ominous%20dark%20blue%20and%20dull%20green%20tones%2C%20no%20text%2C%20no%20watermark%2C%20film%20grain%2C%20eerie%20movie%20still%2C%20high%20detail&width=1600&height=900&seq=mv-b05&orientation=landscape",
    genres: ["horror", "mystery"],
    category: "horror",
    year: 2025,
    releaseDate: "2025-10-31",
    rating: 7.6,
    duration: 104,
    director: "温雨棠",
    cast: ["谢淮安", "林鹤声", "沈亦白"],
    region: "中国大陆",
    tagline: "这趟车只停一站，但没有人知道自己会在哪一站下车",
    synopsis: "五名互不相识的乘客搭上了深夜的末班地铁，当列车驶过本该到站的站点，他们才意识到这趟车正在驶向另一个地方。",
    story: "暴雨夜的末班地铁车厢里只剩下五名乘客。列车驶过终点站却没有停下，窗外的景象重复得像被复制过。随着一名又一名乘客的消失，剩下的人必须在恐慌中找出列车运行的规律。影片以封闭空间和声音恐怖为核心，通过细腻的心理压迫营造持续的紧张感，直到最后一刻才揭开真相的另一面。",
    popularity: 73,
    ratingBreakdown: { story: 7.7, acting: 7.4, visual: 7.9, music: 7.5 },
  },
  {
    id: "6",
    title: "山城故事",
    enTitle: "Tales of the Mountain City",
    poster: "https://readdy.ai/api/search-image?query=cinematic%20drama%20movie%20poster%20of%20a%20winding%20hillside%20town%20with%20dense%20low%20buildings%20and%20warm%20evening%20light%2C%20lone%20figure%20walking%20a%20steep%20stairway%2C%20deep%20blue%20shadows%20and%20amber%20highlights%2C%20no%20text%2C%20no%20watermark%2C%20film%20grain%2C%20high%20detail%2C%20emotional%20tone&width=600&height=900&seq=mv-p06&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20hillside%20city%20with%20layered%20buildings%20and%20steep%20stairs%20at%20dusk%2C%20warm%20window%20lights%20scattered%20across%20the%20slope%2C%20deep%20blue%20atmosphere%2C%20no%20text%2C%20no%20watermark%2C%20film%20grain%2C%20high%20detail&width=1600&height=900&seq=mv-b06&orientation=landscape",
    genres: ["drama"],
    category: "drama",
    year: 2025,
    releaseDate: "2025-06-20",
    rating: 8.5,
    duration: 132,
    director: "江子野",
    cast: ["罗砚书", "温雨棠", "程未然"],
    region: "中国大陆",
    tagline: "所有离开的人，最后都会顺着台阶走回来",
    synopsis: "一位多年未归的摄影师回到山城老家，用镜头重新认识这座正在被时间改变的城市，也重新认识自己的家人。",
    story: "摄影师陆行舟因工作离开家乡十余年，母亲的病让他再次踏上那些熟悉又陌生的台阶。镜头里，老邻居、小面馆、消失的缆车一一浮现；镜头外，他与固执的父亲之间仍隔着一道沉默。在为期一个月的停留里，他用影像记录城市变迁，也逐渐读懂父母未曾说出口的牵挂。影片以温润的叙事和真实的生活质感，讲述归乡与和解。",
    popularity: 82,
    ratingBreakdown: { story: 8.8, acting: 8.9, visual: 8.4, music: 8.2 },
  },
  {
    id: "7",
    title: "超能小队",
    enTitle: "The Mighty Squad",
    poster: "https://readdy.ai/api/search-image?query=cinematic%20animated%20adventure%20movie%20poster%20of%20a%20colorful%20team%20of%20young%20heroes%20leaping%20across%20a%20bright%20stylized%20cityscape%2C%20vivid%20orange%20red%20and%20deep%20blue%20palette%2C%20playful%20dynamic%20energy%2C%20no%20text%2C%20no%20watermark%2C%20high%20detail%2C%20stylized%203d%20render&width=600&height=900&seq=mv-p07&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20colorful%20stylized%20animated%20cityscape%20with%20soaring%20skyscrapers%20and%20bright%20dynamic%20sky%2C%20vivid%20orange%20and%20blue%20palette%2C%20playful%20energetic%20atmosphere%2C%20no%20text%2C%20no%20watermark%2C%20high%20detail%2C%20stylized%203d%20render&width=1600&height=900&seq=mv-b07&orientation=landscape",
    genres: ["animation", "adventure"],
    category: "animation",
    year: 2026,
    releaseDate: "2026-08-01",
    rating: 8.3,
    duration: 98,
    director: "韩之遥",
    cast: ["白鹿鸣", "苏眠", "林鹤声"],
    region: "中国大陆",
    tagline: "我们不是最强的，但一定是最默契的",
    synopsis: "五个性格迥异的孩子意外获得不同的超能力，为了守护住生活的小镇，他们必须学会把彼此的长处拼在一起。",
    story: "在一座看似普通的海边小镇，五个孩子因为一次奇妙的星象事件各自获得了不同的能力：有人能听见远处的声音，有人能短暂地停留时间。起初他们只把能力当作游戏，直到小镇受到威胁，他们才意识到真正的力量来自默契。影片用明亮饱满的色彩和轻快的节奏，讲述关于勇气、友谊与团队协作的成长故事。",
    popularity: 88,
    ratingBreakdown: { story: 8.2, acting: 8.0, visual: 8.9, music: 8.5 },
  },
  {
    id: "8",
    title: "爆笑一家人",
    enTitle: "Laughing All the Way",
    poster: "https://readdy.ai/api/search-image?query=cinematic%20family%20comedy%20movie%20poster%20of%20a%20cheerful%20messy%20living%20room%20with%20warm%20sunny%20light%20and%20playful%20props%20scattered%20around%2C%20vivid%20warm%20red%20and%20cream%20palette%2C%20no%20text%2C%20no%20watermark%2C%20high%20detail%2C%20bright%20stylized%20composition&width=600&height=900&seq=mv-p08&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20cozy%20warm%20family%20apartment%20with%20sunlight%20streaming%20through%20windows%20and%20playful%20everyday%20objects%2C%20cheerful%20warm%20tones%2C%20no%20text%2C%20no%20watermark%2C%20high%20detail%2C%20stylized%20bright%20render&width=1600&height=900&seq=mv-b08&orientation=landscape",
    genres: ["comedy"],
    category: "comedy",
    year: 2026,
    releaseDate: "2026-09-05",
    rating: 7.9,
    duration: 112,
    director: "罗景辰",
    cast: ["韩之遥", "白鹿鸣", "顾知遥"],
    region: "中国大陆",
    tagline: "这个家唯一的传统，就是没有一天是正常的",
    synopsis: "为了给奶奶办一场完美的八十大寿，鸡飞狗跳的一家人开始了一场漏洞百出的秘密筹备。",
    story: "老周家的三代人各有各的毛病，唯独对奶奶的八十大寿格外上心。为了给她一个惊喜，全家人决定瞒着她准备一场盛大的聚会——结果计划从第一天就漏洞百出：订错的蛋糕、走漏的消息、临时叛变的小辈，让筹备变成了一场连环乌龙。影片用密集的笑点和温暖的底色，讲述一个普通家庭鸡飞狗跳又彼此依靠的日常。",
    popularity: 79,
    ratingBreakdown: { story: 7.6, acting: 8.0, visual: 7.8, music: 7.5 },
  },
  {
    id: "9",
    title: "星海远征",
    enTitle: "Expedition to the Stars",
    poster: "https://readdy.ai/api/search-image?query=cinematic%20epic%20space%20adventure%20movie%20poster%20of%20a%20sleek%20starship%20approaching%20a%20distant%20ringed%20planet%20surrounded%20by%20nebulae%2C%20deep%20blue%20and%20violet%20free%20cosmic%20tones%20with%20a%20single%20red%20accent%20light%2C%20no%20text%2C%20no%20watermark%2C%20high%20detail%2C%20epic%20composition&width=600&height=900&seq=mv-p09&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20deep%20space%20scene%20with%20a%20giant%20ringed%20planet%20and%20colorful%20star%20nebula%2C%20a%20small%20starship%20silhouette%2C%20deep%20blue%20and%20teal%20cosmic%20tones%2C%20no%20text%2C%20no%20watermark%2C%20high%20detail%2C%20epic%20movie%20still&width=1600&height=900&seq=mv-b09&orientation=landscape",
    genres: ["sci-fi", "adventure"],
    category: "sci-fi",
    year: 2025,
    releaseDate: "2025-11-22",
    rating: 8.6,
    duration: 148,
    director: "周望川",
    cast: ["程未然", "沈亦白", "罗砚书"],
    region: "中国大陆",
    tagline: "我们出发，是为了让回家的路更长一点",
    synopsis: "一支远航船队驶向已知星域之外，去寻找一份可能决定人类未来的信号来源，而回家的路正随着距离不断变窄。",
    story: "人类首次开启跨星域远航计划，船队带着有限的资源驶向未知。航行中，船员们发现目标信号并非自然形成，而更像是一种等待已久的邀请。随着探索深入，团队内部在继续前行与折返之间产生分歧。影片以宏大的宇宙景观和细腻的人物关系，讨论探索的意义、牺牲与眷恋。",
    popularity: 93,
    ratingBreakdown: { story: 8.7, acting: 8.4, visual: 9.3, music: 8.8 },
  },
  {
    id: "10",
    title: "无声告白",
    enTitle: "A Silent Confession",
    poster: "https://readdy.ai/api/search-image?query=cinematic%20romantic%20drama%20movie%20poster%20of%20two%20hands%20almost%20touching%20across%20a%20sunlit%20window%2C%20soft%20warm%20light%20with%20deep%20blue%20shadows%20and%20muted%20red%20accents%2C%20tender%20emotional%20atmosphere%2C%20no%20text%2C%20no%20watermark%2C%20film%20grain%2C%20high%20detail&width=600&height=900&seq=mv-p10&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20sunlit%20quiet%20balcony%20with%20soft%20curtains%20and%20plants%2C%20warm%20late%20afternoon%20light%20with%20deep%20blue%20shadows%2C%20peaceful%20emotional%20tone%2C%20no%20text%2C%20no%20watermark%2C%20film%20grain%2C%20high%20detail&width=1600&height=900&seq=mv-b10&orientation=landscape",
    genres: ["romance", "drama"],
    category: "romance",
    year: 2026,
    releaseDate: "2026-06-14",
    rating: 8.2,
    duration: 121,
    director: "许清晏",
    cast: ["温雨棠", "顾知遥", "程未然"],
    region: "中国大陆",
    tagline: "有些话从来没有说出口，却已经被听懂了",
    synopsis: "一位习惯用文字代替语言的图书管理员，与一位能读懂细微动作的舞蹈老师，在同一栋楼里悄悄靠近彼此。",
    story: "图书管理员林知夏天生不擅长当面表达，习惯把想说的话写进纸条，夹进归还的书里。楼上的舞蹈老师沈清在一次偶然中发现了这些纸条，并开始用类似的方式回应。两人在同一栋老楼里隔着楼层互相留言，慢慢靠近。影片用安静细腻的镜头，讲述一段发生在日常缝隙里的温柔爱情。",
    popularity: 80,
    ratingBreakdown: { story: 8.3, acting: 8.5, visual: 8.1, music: 8.4 },
  },
  {
    id: "11",
    title: "暗巷追凶",
    enTitle: "Chase in the Dark Alley",
    poster: "https://readdy.ai/api/search-image?query=cinematic%20crime%20thriller%20movie%20poster%20of%20a%20detective%20silhouette%20standing%20in%20a%20narrow%20rain-soaked%20alley%20with%20a%20single%20streetlight%2C%20deep%20navy%20shadows%20and%20crimson%20red%20neon%20reflection%2C%20no%20text%2C%20no%20watermark%2C%20film%20grain%2C%20high%20detail%2C%20tense%20mood&width=600&height=900&seq=mv-p11&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20narrow%20rainy%20city%20alley%20at%20night%20with%20wet%20cobblestones%20and%20glowing%20neon%20signs%2C%20deep%20blue%20and%20crimson%20reflections%2C%20no%20text%2C%20no%20watermark%2C%20film%20grain%2C%20tense%20movie%20still%2C%20high%20detail&width=1600&height=900&seq=mv-b11&orientation=landscape",
    genres: ["action", "mystery"],
    category: "mystery",
    year: 2025,
    releaseDate: "2025-09-09",
    rating: 7.8,
    duration: 116,
    director: "秦墨白",
    cast: ["林鹤声", "江子野", "谢淮安"],
    region: "中国大陆",
    tagline: "真相不在巷子的尽头，而在追的人心里",
    synopsis: "一名固执的老刑警追查一桩沉寂多年的旧案，随着线索重新浮现，他发现最不愿面对的答案可能就在身边。",
    story: "刑警老韩多年来始终放不下那桩悬案。当一条新的线索意外出现，他重新走访了当年的每一个证人，也重新审视了自己当年的判断。追查过程中，他与年轻的搭档在方法与信任上不断摩擦，却又在一次次擦身而过的危险中建立默契。影片以冷硬的影像风格和扎实的案件推进，讨论执念、真相与代价。",
    popularity: 76,
    ratingBreakdown: { story: 8.0, acting: 8.1, visual: 7.6, music: 7.4 },
  },
  {
    id: "12",
    title: "时间旅人",
    enTitle: "The Time Traveler",
    poster: "https://readdy.ai/api/search-image?query=cinematic%20science%20fiction%20movie%20poster%20of%20a%20figure%20walking%20through%20a%20fractured%20mirror%20corridor%20with%20glowing%20blue%20time%20lines%2C%20deep%20navy%20and%20electric%20teal%20palette%20with%20a%20red%20accent%2C%20surreal%20atmosphere%2C%20no%20text%2C%20no%20watermark%2C%20film%20grain%2C%20high%20detail&width=600&height=900&seq=mv-p12&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20surreal%20corridor%20of%20fractured%20mirrors%20and%20glowing%20blue%20time%20lines%20stretching%20into%20infinity%2C%20deep%20navy%20and%20teal%20tones%2C%20no%20text%2C%20no%20watermark%2C%20film%20grain%2C%20epic%20movie%20still%2C%20high%20detail&width=1600&height=900&seq=mv-b12&orientation=landscape",
    genres: ["sci-fi"],
    category: "sci-fi",
    year: 2026,
    releaseDate: "2026-10-01",
    rating: 8.8,
    duration: 138,
    director: "周望川",
    cast: ["沈亦白", "苏敬川", "白鹿鸣"],
    region: "中国大陆",
    tagline: "他走过无数个昨天，只为回到同一个今天",
    story: "物理学者简舟在一次实验事故中转入了时间之外的空间，他可以在不同的时间里穿行，却无法回到最初的那个下午。为了弥补一个无法挽回的遗憾，他一次又一次地修正过去，却发现每改变一件事，都会在别处留下新的缺口。影片用精巧的结构和富有情感的叙事，探讨时间、选择与告别。",
    synopsis: "一位物理学者意外获得了在时间里穿行的能力，他反复修正过去，却发现每改一处，都会在别处留下新的遗憾。",
    popularity: 96,
    ratingBreakdown: { story: 9.1, acting: 8.6, visual: 8.9, music: 8.7 },
  },
  {
    id: "13",
    title: "荒原猎手",
    enTitle: "Hunter of the Wasteland",
    poster: "https://readdy.ai/api/search-image?query=cinematic%20adventure%20movie%20poster%20of%20a%20weathered%20traveler%20standing%20on%20a%20vast%20red%20desert%20wasteland%20under%20a%20stormy%20navy%20sky%2C%20dust%20and%20dramatic%20light%20rays%2C%20crimson%20accent%20scarf%2C%20no%20text%2C%20no%20watermark%2C%20film%20grain%2C%20high%20detail&width=600&height=900&seq=mv-p13&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20endless%20red%20desert%20canyon%20under%20a%20dramatic%20stormy%20deep%20navy%20sky%20with%20dust%20haze%20and%20light%20rays%2C%20no%20text%2C%20no%20watermark%2C%20film%20grain%2C%20epic%20movie%20still%2C%20high%20detail&width=1600&height=900&seq=mv-b13&orientation=landscape",
    genres: ["adventure", "action"],
    category: "adventure",
    year: 2025,
    releaseDate: "2025-08-15",
    rating: 7.7,
    duration: 126,
    director: "罗景辰",
    cast: ["江子野", "林鹤声", "苏敬川"],
    region: "中国大陆",
    tagline: "在没有地图的地方，方向由自己决定",
    synopsis: "一名靠带路为生的荒原向导接下了一单危险的任务，穿越无人区护送一支队伍，途中所有人都必须面对自己的秘密。",
    story: "荒原向导老陈以熟悉地形著称，却从不询问雇主的来意。这一次，他受托护送一支陌生的队伍穿越号称“有去无回”的无人区。一路上，恶劣的环境与队伍内部的不信任同时逼近。老陈不得不在坚持原则与保全性命之间反复权衡。影片以壮阔的自然景观和硬朗的人物塑造，讲述一场关于信任与选择的冒险。",
    popularity: 72,
    ratingBreakdown: { story: 7.6, acting: 7.8, visual: 8.2, music: 7.3 },
  },
  {
    id: "14",
    title: "云端之约",
    enTitle: "A Promise in the Clouds",
    poster: "https://readdy.ai/api/search-image?query=cinematic%20romance%20movie%20poster%20of%20two%20figures%20on%20a%20misty%20mountain%20summit%20above%20a%20sea%20of%20clouds%20at%20golden%20hour%2C%20soft%20warm%20light%20with%20deep%20blue%20shadows%2C%20gentle%20romantic%20tone%2C%20no%20text%2C%20no%20watermark%2C%20film%20grain%2C%20high%20detail&width=600&height=900&seq=mv-p14&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20mountain%20summit%20above%20a%20vast%20sea%20of%20clouds%20at%20sunrise%2C%20warm%20golden%20light%20with%20deep%20blue%20valley%20shadows%2C%20no%20text%2C%20no%20watermark%2C%20film%20grain%2C%20high%20detail&width=1600&height=900&seq=mv-b14&orientation=landscape",
    genres: ["romance"],
    category: "romance",
    year: 2026,
    releaseDate: "2026-05-20",
    rating: 8.0,
    duration: 108,
    director: "温雨棠",
    cast: ["顾知遥", "苏眠", "温雨棠"],
    region: "中国大陆",
    tagline: "我们约好在云散开的地方再见",
    synopsis: "两名登山向导在一次暴风雪中失散，多年后他们在同一座山的两端，用不同的方式寻找着当年的约定。",
    story: "登山向导周野和气象观测员叶岚在一次攀登中遭遇暴风雪，被迫分头撤离。多年后，周野回到那座山，成为了一支登山队的领队；而叶岚则在山下的观测站工作。两人隔着一整座山，却都记得当年在云端许下的约定。影片用开阔的山景和含蓄的情感，讲述一段关于等待与重逢的故事。",
    popularity: 78,
    ratingBreakdown: { story: 7.9, acting: 8.2, visual: 8.3, music: 8.0 },
  },
  {
    id: "15",
    title: "午夜来电",
    enTitle: "Call at Midnight",
    poster: "https://readdy.ai/api/search-image?query=cinematic%20horror%20movie%20poster%20of%20an%20old%20rotary%20telephone%20ringing%20on%20a%20dark%20wooden%20table%20lit%20by%20a%20single%20cold%20blue%20lamp%2C%20deep%20navy%20shadows%20with%20faint%20red%20glow%2C%20creepy%20atmosphere%2C%20no%20text%2C%20no%20watermark%2C%20film%20grain%2C%20high%20detail&width=600&height=900&seq=mv-p15&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20dim%20old%20room%20at%20night%20with%20an%20antique%20telephone%20and%20cold%20blue%20light%20through%20a%20cracked%20window%2C%20eerie%20deep%20navy%20tones%20with%20faint%20red%20glow%2C%20no%20text%2C%20no%20watermark%2C%20film%20grain%2C%20high%20detail&width=1600&height=900&seq=mv-b15&orientation=landscape",
    genres: ["horror"],
    category: "horror",
    year: 2025,
    releaseDate: "2025-07-04",
    rating: 7.4,
    duration: 96,
    director: "韩之遥",
    cast: ["谢淮安", "程未然", "白鹿鸣"],
    region: "中国大陆",
    tagline: "接起电话的人，都会忘记自己是谁",
    synopsis: "一位独居的插画师每到午夜都会接到同一个无声来电，当她终于决定回拨，平静的生活被彻底打破。",
    story: "插画师安宁搬进一间老旧公寓后，每晚午夜都会接到同一个没有声音的电话。起初她以为是骚扰，直到来电的号码开始出现在她的画稿里。为了弄清真相，她回拨了那个号码，随之而来的是记忆的错乱与现实的扭曲。影片以声音和留白营造持续的不安，讲述一个人如何在恐惧中找回自己。",
    popularity: 68,
    ratingBreakdown: { story: 7.2, acting: 7.5, visual: 7.7, music: 7.6 },
  },
  {
    id: "16",
    title: "小城大厨",
    enTitle: "The Big Chef of a Small Town",
    poster: "https://readdy.ai/api/search-image?query=cinematic%20warm%20comedy%20drama%20movie%20poster%20of%20a%20steaming%20wok%20on%20a%20rustic%20stove%20in%20a%20cozy%20small%20town%20kitchen%2C%20warm%20amber%20light%20with%20deep%20blue%20shadows%2C%20appetizing%20homey%20tone%2C%20no%20text%2C%20no%20watermark%2C%20high%20detail&width=600&height=900&seq=mv-p16&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20cozy%20small%20town%20kitchen%20counter%20full%20of%20fresh%20ingredients%20and%20steaming%20pots%2C%20warm%20amber%20light%20with%20deep%20blue%20shadows%2C%20homey%20atmosphere%2C%20no%20text%2C%20no%20watermark%2C%20high%20detail&width=1600&height=900&seq=mv-b16&orientation=landscape",
    genres: ["comedy", "drama"],
    category: "drama",
    year: 2026,
    releaseDate: "2026-04-11",
    rating: 8.4,
    duration: 124,
    director: "江子野",
    cast: ["白鹿鸣", "罗砚书", "韩之遥"],
    region: "中国大陆",
    tagline: "一道菜的味道，藏着一座城的记忆",
    synopsis: "一位落魄的大厨回到家乡小城接手父亲留下的小馆子，用一道道家常菜重新找回生活的滋味与人情味。",
    story: "曾经在大城市风光一时的大厨方叙因一次失败回到家乡，接手了父亲留下的小馆子。他起初只想尽快把店盘出去，却在每天招待街坊的过程中，逐渐被那些熟悉的味道和人情牵绊。为了守住父亲留下的招牌菜，他与挑剔的老食客、倔强的学徒一起闹出不少笑话。影片用温暖的叙事和鲜活的美食细节，讲述回归与传承。",
    popularity: 81,
    ratingBreakdown: { story: 8.5, acting: 8.3, visual: 8.2, music: 8.1 },
  },
  {
    id: "17",
    title: "铁血防线",
    enTitle: "Iron Line",
    poster: "https://readdy.ai/api/search-image?query=cinematic%20war%20action%20movie%20poster%20of%20a%20group%20of%20soldiers%20silhouettes%20defending%20a%20ruined%20bridge%20at%20dawn%2C%20smoke%20and%20embers%2C%20deep%20navy%20sky%20with%20crimson%20red%20light%2C%20dramatic%20grim%20tone%2C%20no%20text%2C%20no%20watermark%2C%20film%20grain%2C%20high%20detail&width=600&height=900&seq=mv-p17&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20ruined%20river%20bridge%20at%20dawn%20with%20smoke%20and%20embers%20floating%20in%20the%20air%2C%20deep%20navy%20sky%20with%20crimson%20red%20horizon%20light%2C%20no%20text%2C%20no%20watermark%2C%20film%20grain%2C%20epic%20movie%20still%2C%20high%20detail&width=1600&height=900&seq=mv-b17&orientation=landscape",
    genres: ["action"],
    category: "action",
    year: 2025,
    releaseDate: "2025-05-01",
    rating: 8.1,
    duration: 150,
    director: "林砚舟",
    cast: ["苏敬川", "江子野", "谢淮安"],
    region: "中国大陆",
    tagline: "守住这座桥，就是守住身后的一切",
    synopsis: "一支人数悬殊的小分队奉命守住一座关键桥梁，在有限的弹药与时间里，他们用智慧与意志筑起最后的防线。",
    story: "在战局最关键的节点，一支临时拼凑的小分队接到命令：不惜代价守住一座桥梁，为后方争取时间。面对装备精良、人数众多的对手，队长带领队员利用地形与有限的资源布置防线。在漫长的对峙中，恐惧、疲惫与牺牲不断考验着每一个人。影片以扎实的战术细节和克制的情感表达，刻画一群普通人在极限处境下的坚守。",
    popularity: 85,
    ratingBreakdown: { story: 8.2, acting: 8.3, visual: 8.0, music: 8.1 },
  },
  {
    id: "18",
    title: "幻梦乐园",
    enTitle: "Dream Park",
    poster: "https://readdy.ai/api/search-image?query=cinematic%20animated%20fantasy%20movie%20poster%20of%20a%20whimsical%20floating%20amusement%20park%20among%20glowing%20clouds%20at%20dusk%2C%20vivid%20orange%20and%20deep%20blue%20palette%20with%20warm%20lights%2C%20dreamy%20playful%20atmosphere%2C%20no%20text%2C%20no%20watermark%2C%20high%20detail%2C%20stylized%20render&width=600&height=900&seq=mv-p18&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20widescreen%20whimsical%20floating%20amusement%20park%20among%20glowing%20pastel%20clouds%20at%20dusk%2C%20vivid%20orange%20and%20deep%20blue%20palette%20with%20warm%20lights%2C%20dreamy%20atmosphere%2C%20no%20text%2C%20no%20watermark%2C%20high%20detail%2C%20stylized%20render&width=1600&height=900&seq=mv-b18&orientation=landscape",
    genres: ["animation"],
    category: "animation",
    year: 2026,
    releaseDate: "2026-03-18",
    rating: 8.5,
    duration: 102,
    director: "韩之遥",
    cast: ["苏眠", "顾知遥", "白鹿鸣"],
    region: "中国大陆",
    tagline: "在梦里，所有没说完的道别都还有机会",
    synopsis: "一个害怕道别的孩子在梦中走进一座漂浮的乐园，遇见一群同样不愿醒来的人，她学会的最后一课是好好说再见。",
    story: "小女孩言言最害怕的事情就是告别。一次睡梦中，她走进了一座漂浮在云端、只在黄昏出现的乐园。这里的游客都曾有过未能说出口的再见。在乐园向导的陪伴下，言言经历了无数奇妙的游戏，也渐渐理解了告别的意义。影片用天马行空的想象和温暖的画面，讲述一个关于成长、记忆与放手的故事。",
    popularity: 87,
    ratingBreakdown: { story: 8.4, acting: 8.1, visual: 9.0, music: 8.5 },
  },
];